import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MultilineInput } from "react-input-multiline";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { GrPrevious } from "react-icons/gr";
import { GrNext } from "react-icons/gr";
import { BiTrendingUp } from "react-icons/bi";
import { useSnackbar } from "../contexts/SnackbarContext";
import { TextField, Paper, IconButton, Box, Typography, Chip, Card, CardMedia, Button as MuiButton, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { AttachFile, Save, Delete, Edit, Close } from "@mui/icons-material";

export default function JournalRegistration(props) {
  const location = useLocation();
  const { showSnackbar } = useSnackbar();
  const [modalVisible, setModalVisible] = useState(false);
  const [imageViewerOpen, setImageViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  const handleClose = () => {
    setModalVisible(false);
  };

  const handleImageClick = (imageUrl) => {
    setCurrentImage(imageUrl);
    setImageViewerOpen(true);
  };

  const handleImageViewerClose = () => {
    setImageViewerOpen(false);
    setCurrentImage("");
  };
  const navigation = useNavigate();
  //   const auth = `Bearer  ${AsyncStorage.getItem('dtt_token')}`
  const [name, setName] = useState({ value: "", error: "" });
  const [date, setDate] = useState({ value: "", error: "" });
  const [type, setType] = useState({ value: "", error: "" });
  const [submitting, setSubmitting] = useState(false);
  const [comment, setComment] = useState("");
  const [id, setId] = useState(location.state ? location.state.id : "");
  const [book, setBook] = useState(location.state ? location.state.list : "");
  const [index, setIndex] = useState(
    location.state ? location.state.index : ""
  );

  const [picture, setPicture] = useState("");
  const dated = new Date().toLocaleString() + "";
  const [postData, setPostData] = useState({});
  const AddJournal = () => {
    const token = localStorage.getItem("dtt_PatientToken");
    const patientId = localStorage.getItem("dtt_PatientId");
    setSubmitting(true);
    var pdata = postData;
    if (pdata == null) {
      pdata = {
        comment: comment,
        patientId: parseInt(patientId),
        id: id,
        name: "",
        date: "",
        type: "",
        notes: "",
        inactive: "",
        archive: "false",
        createdDate: "",
        updatedDate: "",
        createdBy: "",
        updatedBy: "",
        clientCreatedDate: "",
        clientUpdatedDate: "",
        pJournalAttachmentslist: [],
      };
    } else {
      pdata.comment = comment;
      pdata.patientId = parseInt(patientId);
      pdata.date = dated;
      // setPostData(pdata)
    }
    if (fileList.length > 0) {
      pdata.pJournalAttachmentslist = fileList;
    }
    console.log("pdata: ", pdata);

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientJournal/AddPatientJournal`,
        pdata,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          navigation("/Journal");
        } else {
          setSubmitting(false);
          showSnackbar('Oops! Something went wrong. Please try again.', 'error');
        }
      })
      .catch((error) => {
        console.error("Error saving journal:", error);
        setSubmitting(false);
        showSnackbar('Error saving journal. Please try again.', 'error');
      });
  };
  const [singleFile, setSingleFile] = useState(true);

  const [fileList, setFileList] = useState([]);
  const [attachments, setattachments] = useState([]);
  const [dataReceived, setDataReceived] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem("dtt_PatientToken");
    setDataReceived(false);

    if (id > 0) {
      axios
        .get(
          `${
            process.env.REACT_APP_API_URL
          }/PatientJournal/PatientJournalById?Id=${parseInt(id)}`,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          setPostData(response.data);
          setattachments(response.data.pJournalAttachmentslist);
          // console.warn("postData!", postData);
          setComment(response.data.comment);
          setDataReceived(true);
          // console.log("comment", response.data.comment);
        })
        .catch((error) => {
          console.warn("There was an error!", error);
        });
    } else setDataReceived(true);
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [id]);

  const onFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    var base64 = await convertBase64(file);
    base64 = base64.split("base64,")[1];

    var fileObj = {
      base64: base64,
      base64Extantions: file.name,
    };

    setFileList([...fileList, fileObj]);
    showSnackbar(`File "${file.name}" selected successfully!`, 'success');
    console.log("Selected file:", file.name);

    // Clear the input so the same file can be selected again
    event.target.value = '';
  };
  function convertBase64(file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }
  return (
    <>
      {" "}
      {submitting ? (
        <Spinner
          animation="border"
          variant="warning"
          style={{
            width: "50px",
            height: "50px",
            position: "absolute",
            left: "50%",
            top: "50%",
            marginLeft: "-25px",
            marginTop: "-25px",
            zIndex: 1000,
          }}
        />
      ) : null}
      <Container style={{ maxWidth: "1200px", marginTop: "20px", marginBottom: "30px" }}>
        {/* Page Header */}
        {book.length > 0 && (
          <Box sx={{ marginBottom: 2 }}>
            <Typography variant="subtitle1" sx={{ color: "#666" }}>
              Entry from: <strong>{book[index].date}</strong>
            </Typography>
          </Box>
        )}

        <Row style={{ padding: "10px" }}>
          {/* <BackButton goBack={Journal} /> */}
          {/* <input
        returnKeyType="next"
        placeholder="Name"
        value={name.value}
        onChangeText={(text) => setName({ value: text, error: '' })}
        error={!!name.error}
        errorText={name.error}
        autoCapitalize="none"
      /> */}

          {/* <input
        placeholder="Date"
        returnKeyType="next"
        value={date.value}
        onChangeText={(text) => setDate({ value: text, error: '' })}
        error={!!date.error}    
        errorText={date.error}
   
      {/* </InputGroup> */}
      {/* <Row>
        <Col className="text-left">
          <label
            style={{
              padding: "10px",
              fontWeight: "bold",
              fontSize: "30px",
              color: "#31A5D7",
            }}
          >
            Begin typing your journal entry here{" "}
          </label>
        </Col>
      </Row> */}
          {dataReceived ? (
            <TextField
              fullWidth
              multiline
              rows={6}
              value={dataReceived ? comment : ""}
              placeholder="Begin Typing Your Journal Entry Here"
              onChange={(e) => setComment(e.target.value)}
              variant="outlined"
              sx={{
                marginBottom: 2,
                "& .MuiOutlinedInput-root": {
                  fontSize: "18px",
                  backgroundColor: "#73C2E3",
                  borderRadius: "4px",
                  "& fieldset": {
                    borderColor: "#31A5D7",
                    borderWidth: "1px",
                  },
                  "&:hover fieldset": {
                    borderColor: "#31A5D7",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#31A5D7",
                    borderWidth: "2px",
                  },
                },
                "& .MuiOutlinedInput-input": {
                  padding: "20px",
                  color: "#000",
                },
              }}
            />
          ) : null}
        </Row>

        {/* Display Newly Selected Files */}
        {fileList && fileList.length > 0 && (
          <Box sx={{ marginBottom: 2, marginTop: 1 }}>
            <Typography variant="body2" fontWeight={600} gutterBottom sx={{ color: "#31A5D7", marginBottom: 1 }}>
              📎 Selected Files ({fileList.length})
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              {fileList.map(function (file, i) {
                return (
                  <Box
                    key={i}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "8px 12px",
                      backgroundColor: "#f0f8ff",
                      borderRadius: "4px",
                      border: "1px solid #31A5D7",
                    }}
                  >
                    <Typography variant="body2" sx={{ color: "#333", fontWeight: 500 }}>
                      📄 {file.base64Extantions}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => {
                        const newFileList = fileList.filter((_, index) => index !== i);
                        setFileList(newFileList);
                        showSnackbar('File removed', 'info');
                      }}
                      sx={{ color: "#e74c3c" }}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}

        {attachments && attachments.length > 0 && (
          <Box sx={{ marginBottom: 2 }}>
            <Typography variant="body2" fontWeight={600} gutterBottom sx={{ color: "#666", marginBottom: 1 }}>
              Attachments ({attachments.length}) - Click to view full size
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {attachments.map(function (item, i) {
                const imageUrl = `${process.env.REACT_APP_Documents_URL}/${encodeURI(item.url)}`;
                return (
                  <img
                    key={i}
                    src={imageUrl}
                    alt={`Attachment ${i + 1}`}
                    onClick={() => handleImageClick(imageUrl)}
                    style={{
                      width: "150px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "4px",
                      border: "1px solid #ddd",
                      cursor: "pointer",
                      transition: "transform 0.2s, box-shadow 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.05)";
                      e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                );
              })}
            </Box>
          </Box>
        )}

          {/* {dataUpdated? (
          fileList.map(function (item, i) {
          console.log("file:", `${item.base64}`);
          return (
            <img
              style={{
                width: "300px",
                height: "150px",
                margin: "5px",
                objectFit: "stretch",
              }}
              src={`${item.base64}`}
            />
          );
        })):''} */}

        {/* Hidden File Input */}
        <input
          id="choosefile"
          style={{ display: "none" }}
          type="file"
          onChange={onFileChange}
        />

        {/* Action Buttons */}
        <Box sx={{ display: "flex", gap: 1, justifyContent: "center", marginTop: 2, flexWrap: "wrap" }}>
          <MuiButton
            variant="contained"
            startIcon={<AttachFile />}
            onClick={() => {
              document.getElementById("choosefile").click();
            }}
            sx={{
              backgroundColor: "#FCBE13",
              color: "#000",
              fontWeight: "bold",
              padding: "10px 20px",
              borderRadius: "5px",
              textTransform: "none",
              fontSize: "16px",
              minWidth: "205px",
              "&:hover": {
                backgroundColor: "#e5ab11",
              },
            }}
          >
            Add Picture/File
          </MuiButton>
          <MuiButton
            variant="contained"
            startIcon={<Save />}
            onClick={AddJournal}
            disabled={submitting}
            sx={{
              backgroundColor: "#FCBE13",
              color: "#000",
              fontWeight: "bold",
              padding: "10px 20px",
              borderRadius: "5px",
              textTransform: "none",
              fontSize: "16px",
              minWidth: "205px",
              "&:hover": {
                backgroundColor: "#e5ab11",
              },
              "&:disabled": {
                backgroundColor: "#ccc",
                color: "#666",
              },
            }}
          >
            Save Journal Entry
          </MuiButton>
          <MuiButton
            variant="contained"
            startIcon={<Delete />}
            onClick={() => {
              setModalVisible(true);
            }}
            sx={{
              backgroundColor: "#FCBE13",
              color: "#000",
              fontWeight: "bold",
              padding: "10px 20px",
              borderRadius: "5px",
              textTransform: "none",
              fontSize: "16px",
              minWidth: "255px",
              "&:hover": {
                backgroundColor: "#e5ab11",
              },
            }}
          >
            Delete this Journal Entry
          </MuiButton>
        </Box>
            <Modal
              style={{ paddingTop: "75px", textAlign: "center" }}
              show={modalVisible}
              onHide={handleClose}
            >
              <Modal.Header closeButton style={{ padding: "5px" }}>
                <Modal.Title style={{ color: "#31A5D7", fontWeight: "bold" }}>
                  Doing This Together
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ fontSize: "25px" }}>
                Do you want to delete this journal entry?{" "}
              </Modal.Body>
              <Modal.Footer style={{ padding: "0px" }}>
                <Container style={{ padding: "0px" }}>
                  <Row>
                    <Col xs={4} md={5} lg={5}></Col>
                    <Col
                      xs={2}
                      md={1}
                      lg={1}
                      style={{ margin: "5px", textAlign: "center" }}
                    >
                      <Button
                        style={{ backgroundColor: "#31A5D7" }}
                        onClick={handleClose}
                      >
                        No
                      </Button>{" "}
                    </Col>
                    <Col
                      xs={2}
                      md={1}
                      lg={1}
                      style={{ margin: "5px", textAlign: "center" }}
                    >
                      <Button
                        style={{ backgroundColor: "#31A5D7" }}
                        // variant="primary"
                        onClick={() => {
                          const token = localStorage.getItem("dtt_PatientToken");
                          axios
                            .post(
                              `${process.env.REACT_APP_API_URL}/PatientJournal/AddPatientJournal`,
                              {
                                id: postData.id,
                                inactive: true,
                                archive: postData.archive,
                                clientCreatedDate: postData.clientCreatedDate,
                                clientUpdatedDate: postData.clientUpdatedDate,
                                comment: postData.comment,
                                createdBy: postData.createdBy,
                                createdDate: postData.createdDate,
                                date: postData.date,
                                name: postData.name,
                                notes: postData.notes,
                                patientId: postData.patientId,
                                type: postData.type,
                                updatedBy: postData.updatedBy,
                                updatedDate: postData.updatedDate,
                                pJournalAttachmentslist:
                                  postData.pJournalAttachmentslist,
                              },
                              {
                                headers: {
                                  "Content-Type": "application/json",
                                  "Access-Control-Allow-Origin": "*",
                                  Authorization: `Bearer ${token}`,
                                },
                              }
                            )
                            .then((response) => {
                              if (response.data) {
                                navigation("/Journal");
                              } else {
                                showSnackbar('Oops! Something went wrong. Please try again.', 'error');
                              }
                            })
                            .catch((error) => {
                              console.error("Error deleting journal:", error);
                              showSnackbar('Error deleting journal. Please try again.', 'error');
                            });
                        }}
                      >
                        Yes
                      </Button>{" "}
                    </Col>
                    <Col xs={4} md={5} lg={5}></Col>
                  </Row>
                </Container>
              </Modal.Footer>
            </Modal>

        {/* Image Viewer Modal */}
        <Dialog
          open={imageViewerOpen}
          onClose={handleImageViewerClose}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.9)",
              boxShadow: "none",
            },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#fff",
              padding: "16px 24px",
            }}
          >
            <Typography variant="h6" sx={{ color: "#fff" }}>
              Attachment Preview
            </Typography>
            <IconButton
              onClick={handleImageViewerClose}
              sx={{
                color: "#fff",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ padding: "24px", textAlign: "center" }}>
            {currentImage && (
              <img
                src={currentImage}
                alt="Full size attachment"
                style={{
                  maxWidth: "100%",
                  maxHeight: "70vh",
                  objectFit: "contain",
                  borderRadius: "8px",
                }}
              />
            )}
          </DialogContent>
        </Dialog>

        <Row>
          <Col className="text-center">
            {index > 0 ? (
              <Button
                className="button"
                type="submit"
                style={{
                  borderRadius: 5,
                  width: "110px",
                  margin: 5,
                  color: "black",
                  fontWeight: "bold",
                  float: "left",
                  textAlign: "center",
                  marginBottom: 10,
                  backgroundColor: "#31A5D7",
                }}
                mode="contained"
                onClick={() => {
                  {
                    setId(book[index - 1].id);
                    setIndex(index - 1);
                  }
                }}
              >
                <GrPrevious style={{ marginBottom: "2px" }} />
                Previous
              </Button>
            ) : (
              ""
            )}
            {index + 1 < book.length ? (
              <Button
                className="button"
                type="submit"
                style={{
                  borderRadius: 5,
                  margin: 5,
                  width: "100px",
                  color: "black",
                  fontWeight: "bold",
                  textAlign: "center",
                  float: "right",
                  marginBottom: 10,
                  backgroundColor: "#31A5D7",
                }}
                mode="contained"
                onClick={() => {
                  {
                    setId(book[index + 1].id);
                    setIndex(index + 1);
                  }
                }}
              >
                Next <GrNext style={{ marginBottom: "2px" }} />
              </Button>
            ) : (
              ""
            )}
            {/* <Button
            style={{ margin: "5px",backgroundColor:'#FCBE13' }}
            mode="contained"
            onClick={() => navigation("/Journal")}
          >
            Go Back on Journal
          </Button> */}
          </Col>
        </Row>
      </Container>
    </>
  );
}
